<template>
    <!-- 副页面样式组件 -->
    <div class="contents section-hero" :style="{ backgroundImage: `url(${bg})`, backgroundSize: 'cover' }">
        <div class="contents_mask" v-if="bg2" :style="{ backgroundImage: 'url(' + bg2 + ')' }"></div>
        <div class="container row">
            <div :class="'col-lg-' + partition[0]" style="position: relative;z-index: 3;">
                <div class="mb-9 pr-2 pl-2">
                    <h5 class="fw_900 c_233dd2">{{ title }}</h5>
                    <h1 class="fw_900 mt-4">{{ subtitle }}</h1>
                    <div class="mt-4">
                        <p class="mb-1" v-for="value in description" :key="value">{{ value }}</p>
                    </div>
                    <button type="button" class="btn btn-outline-success mt-5">{{ buttonText }}</button>
                </div>
            </div>
            <div :class="'col-lg-' + partition[1]" :style="{ justifyContent: direction }" v-if="rightBg">
                <div :style="{ position: 'absolute', bottom: bottom }" class="img_box">
                    <img :src="rightBg" :class="rightBg2 ? `img_box_${imgpar[0]}` : 'img-fluid'" :style="rbgStyle" />
                    <img v-if="rightBg2" :src="rightBg2" :class="'img_box_' + imgpar[1]" :style="rbg2Style" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "mainPage",
    props: {
        title: {
            type: String,
            default: "标题"
        },
        subtitle: {
            type: String,
            default: "副标题"
        },
        description: {
            type: Array,
            default: () => [],
            description: "这是一个主页面的描述"
        },
        buttonText: {
            type: String,
            default: "立即开通"
        },
        bg: {
            type: String,
            default: "",
            description: "背景图片"
        },
        bg2: {
            type: String,
            default: "",
            description: "背景图片2"
        },
        rightBg: {
            type: String,
            default: "",
            description: "右侧图片"
        },
        rightBg2: {
            type: String,
            default: "",
            description: "右侧图片2"
        },
        partition: {
            type: Array,
            default: () => [6, 6],
            description: "右侧内容与左侧内容的宽度比例"
        },
        bottom: {
            type: String,
            default: "unset",
            description: "右侧图片的底部距离"
        },
        direction: {
            type: String,
            default: "center",
            description: "右侧图片的位置"
        },
        imgpar: {
            type: Array,
            default: () => [1, 2],
            description: "图片class名"
        },
        rbg2Style: {
            type: Object,
            default: () => { },
            description: "背景图片2的自定义样式"
        },
        rbgStyle: {
            type: Object,
            default: () => { },
            description: "背景图片1的自定义样式"
        },
    },
    data() {
        return {

        }
    },
};
</script>
<style lang="scss" scoped>
.contents {
    height: var(--main-height);
    width: 100%;
    overflow: hidden;
    // background-image: url('/img/pay/0-_BG-5.png');
    background-position: left bottom;
    background-repeat: no-repeat;
    // background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .contents_mask {
        position: absolute;
        inset: 0;
        background-position: right;
        background-repeat: no-repeat;
    }

    .container {
        height: 100%;
        display: flex;
        // flex-direction: column;

        >div {
            height: var(--main-height);
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .img_box {
            img {
                // box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07) !important;
                border-radius: 10px;
            }

            // display: flex;
            .img_box_1 {
                width: 55%;
                padding: 15px;
            }

            .img_box_2 {
                width: 45%;
                padding: 15px;
            }

        }
    }
}

.fw_900 {
    font-weight: 900;
}

.c_233dd2 {
    color: #233dd2;
}
</style>
